export default __webpack_public_path__ + "static/media/Investment-Banking.abf4758e.jpg";